import { useState } from "react";
import Login from "./Login";
import CallList from "./CallList";

export default function CallListTab() {
  const [authentication, setAuthentication] = useState(
    localStorage.getItem("activation_token") ? true : false
  );

  if (!authentication) {
    return (
      <Login
        onLoginSuccess={() => {
          setAuthentication(true);
        }}
      />
    );
  }

  return <CallList />;
}
